<template>
  <form autocomplete="on" v-on:submit.prevent="$emit('saveOutboundPopup')">
    <div id="outboundContainer" class="vs-con-loading__container p-3">
      <!-- Profile Section -->
      <div class="vs-collapse-item--header pointer" @click="toggleSection('profile')">
        <div class="flex items-center">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="stroke-current text-white w-5 h-5" />
          <strong class="text-white" v-text="$t('profile')"></strong>
        </div>
        <span class="icon-header vs-collapse-item--icon-header" :class="{ 'rotate-arrow-up': !hideSection.profile }">
          <i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i>
        </span>
      </div>
      <div class="p-4" :class="['show', { 'hide-section': hideSection.profile }]">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('member_name')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
                <vs-input v-model="memberFormData.name" class="w-full"/>
                <validation-error :model-error="memberFormErrors.name"></validation-error>
              </div>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('caller_company_name')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
                <vs-input v-model="memberFormData.company_name" class="w-full"/>
                <validation-error :model-error="memberFormErrors.company_name"></validation-error>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('mobile')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
                <vs-input v-model="memberFormData.mobile" class="w-full"/>
                <validation-error :model-error="memberFormErrors.mobile"></validation-error>
              </div>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('landline')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
                <vs-input v-model="memberFormData.landline" class="w-full"/>
                <validation-error :model-error="memberFormErrors.landline"></validation-error>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('age')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
                <vs-input v-model="memberFormData.age" class="w-full"/>
                <validation-error :model-error="memberFormErrors.age"></validation-error>
              </div>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 md:w-1/2 w-full" id="member-group-container">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('member_groups')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
<!--                <v-select :options="groupOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="memberFormData.group_id" class="md:mb-0" />-->
                <select v-model="memberFormData.group_id" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in groupOptions" :key="'category_' + key" :value="option.value">{{ option.label }}</option>
                </select>
                <validation-error :model-error="memberFormErrors.group_id"></validation-error>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 md:w-1/2 w-full" id="level-name-container">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('membership_level')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
<!--                <v-select :options="levelOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="memberFormData.level_id" class="md:mb-0" />-->
                <select v-model="memberFormData.level_id" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in levelOptions" :key="'level_id_' + key" :value="option.value">{{ option.label }}</option>
                </select>
                <validation-error :model-error="memberFormErrors.level_id"></validation-error>
              </div>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('email')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
                <vs-input v-model="memberFormData.email" class="w-full"/>
                <validation-error :model-error="memberFormErrors.email"></validation-error>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-2/12 w-full">
                <strong v-text="$t('address')"></strong>
              </div>
              <div class="vx-col sm:w-10/12 w-full">
                <vs-input v-model="memberFormData.address" class="w-full"/>
                <validation-error :model-error="memberFormErrors.address"></validation-error>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div v-for="(memberCustomField, key) in memberCustomFields" v-bind:key="'memberCustomField_' + key" class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="memberCustomField.title"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
                <template v-if="memberCustomField.type == 'Text'">
                  <vs-input v-model="memberFormData.custom_fields_form_data[key].value" class="w-full"/>
                </template>

                <template v-if="memberCustomField.type == 'Select'">
<!--                  <v-select :options="memberCustomField.options" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="memberFormData.custom_fields_form_data[key].value" class="md:mb-0" />-->
                  <select v-model="memberFormData.custom_fields_form_data[key].value" class="vs-inputx vs-input--input normal md:mb-0">
                    <option value="">{{ $t('please_select') }}</option>
                    <option v-for="(option, key) in memberCustomField.options" :key="'member_custom_fields_' + key" :value="option.value">{{ option.label }}</option>
                  </select>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 md:w-1/2 w-full"></div>
          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <input id="outboundSaveButton" class="vs-component vs-button w-full vs-button-primary vs-button-filled" type="submit" :value="$t('enrollment')"/>
            <!-- <vs-button id="outboundSaveButton" class="w-full" color="primary" type="filled" v-text="$t('enrollment')"></vs-button> -->
          </div>
        </div>
      </div>

      <!-- Counceling Management Section -->
      <div class="vs-collapse-item--header pointer mt-5" @click="toggleSection('counceling-management')">
        <div class="flex items-center">
          <feather-icon icon="PhoneIcon" class="mr-2" svgClasses="stroke-current text-white w-5 h-5" />
          <strong class="text-white" v-text="$t('counseling_management')"></strong>
        </div>
        <span class="icon-header vs-collapse-item--icon-header" :class="{ 'rotate-arrow-up': !hideSection.councelingManagement }">
          <i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i>
        </span>
      </div>
      <div class="p-4" :class="['show', { 'hide-section': hideSection.councelingManagement }]">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('consultant_name')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
                <vs-input v-model="user.name" class="w-full" disabled/>
              </div>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('business_person')"></strong>
                <div style="float: right">
                  <vs-checkbox v-model="consultationFormData.alarm"></vs-checkbox>
                </div>
              </div>
              <div class="vx-col sm:w-8/12 w-full" id="business-person-container">
<!--                <v-select :options="extensionOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.assigned_agent_id" class="md:mb-0" />-->
                <select v-model="consultationFormData.assigned_agent_id" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in extensionOptions" :key="'assigned_agent_id_' + key" :value="option.value">{{ option.label }}</option>
                </select>
                <validation-error :model-error="consultationFormErrors.assigned_agent_id"></validation-error>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 md:w-1/2 w-full" id="classification-container">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('classification')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
<!--                <v-select :options="divisionOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.division_id" class="md:mb-0" />-->
                <select v-model="consultationFormData.division_id" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in divisionOptions" :key="'division_id_' + key" :value="option.value">{{ option.label }}</option>
                </select>
                <validation-error :model-error="consultationFormErrors.division_id"></validation-error>
              </div>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 md:w-1/2 w-full" id="treatment-result-container">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('treatment_result')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
<!--                <v-select :options="resultOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.result_type_id" class="md:mb-0" />-->
                <select v-model="consultationFormData.result_type_id" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in resultOptions" :key="'result_type_id_' + key" :value="option.value">{{ option.label }}</option>
                </select>
                <validation-error :model-error="consultationFormErrors.result_type_id"></validation-error>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 md:w-1/2 w-full" id="big-container">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('big')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
<!--                <v-select :options="bigOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.big_type_id" class="md:mb-0" />-->
                <select v-model="consultationFormData.big_type_id" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in bigOptions" :key="'big_type_id_' + key" :value="option.value">{{ option.label }}</option>
                </select>
                <validation-error :model-error="consultationFormErrors.big_type_id"></validation-error>
              </div>
            </div>
          </div>

          <div class="vx-col sm:w-1/2 md:w-1/2 w-full" id="middle-class-container">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="$t('middle_class')"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
<!--                <v-select :options="smallOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.small_type_id" class="md:mb-0" />-->
                <select v-model="consultationFormData.small_type_id" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in smallOptions" :key="'small_type_id_' + key" :value="option.value">{{ option.label }}</option>
                </select>
                <validation-error :model-error="consultationFormErrors.small_type_id"></validation-error>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div v-for="(consultationCustomField, key) in consultationCustomFields" v-bind:key="'consultationCustomField_' + key" class="vx-col sm:w-1/2 md:w-1/2 w-full">
            <div class="vx-row align-center mb-3">
              <div class="vx-col sm:w-4/12 w-full">
                <strong v-text="consultationCustomField.title"></strong>
              </div>
              <div class="vx-col sm:w-8/12 w-full">
                <template v-if="consultationCustomField.type == 'Text'">
                  <vs-input v-model="consultationFormData.custom_fields_form_data[key].value" class="w-full"/>
                </template>

                <template v-if="consultationCustomField.type == 'Select'">
<!--                  <v-select :options="consultationCustomField.options" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.custom_fields_form_data[key].value" class="md:mb-0" />-->
                  <select v-model="consultationFormData.custom_fields_form_data[key].value" class="vs-inputx vs-input--input normal md:mb-0">
                    <option value="">{{ $t('please_select') }}</option>
                    <option v-for="(option, key) in consultationCustomField.options" :key="'consultation_custom_fields_' + key" :value="option.value">{{ option.label }}</option>
                  </select>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row align-center mb-3">
          <div class="vx-col sm:w-2/12 w-full">
            <strong v-text="$t('consulting_title')"></strong>
          </div>
          <div class="vx-col sm:w-10/12 w-full">
            <vs-input v-model="consultationFormData.title" name="title" class="w-full"/>
            <validation-error :model-error="consultationFormErrors.title"></validation-error>
          </div>
        </div>
        <div class="vx-row align-center mb-3">
          <div class="vx-col sm:w-2/12 w-full">
            <strong v-text="$t('consultation_contents')"></strong>
          </div>
          <div class="vx-col sm:w-10/12 w-full">
            <vs-textarea class="mb-0" v-model="consultationFormData.content" />
            <validation-error :model-error="consultationFormErrors.content"></validation-error>
          </div>
        </div>
      </div>

      <!-- More History Section -->
      <div class="vs-collapse-item--header pointer mt-5" @click="toggleSection('more-history')">
        <div class="flex items-center">
          <feather-icon icon="ListIcon" class="mr-2" svgClasses="stroke-current text-white w-5 h-5" />
          <strong class="text-white" v-text="$t('more_history')"></strong>
        </div>
        <span class="icon-header vs-collapse-item--icon-header" :class="{ 'rotate-arrow-up': !hideSection.moreHistory }">
          <i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i>
        </span>
      </div>
      <div class="p-4 mb-10" :class="['show', { 'hide-section': hideSection.moreHistory }]">
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mb-3">
              <vs-table hover-flat v-if="consultationHistory && consultationHistory.length" :data="consultationHistory">

                <template slot="thead">
                  <vs-th class="text-center" v-text="$t('no')"></vs-th>
                  <vs-th v-text="$t('inquiry')"></vs-th>
                  <vs-th v-text="$t('status')"></vs-th>
                  <vs-th v-text="$t('join_now')"></vs-th>
                  <vs-th v-text="$t('subscription_time')"></vs-th>
                  <vs-th v-text="$t('consulting_title')"></vs-th>
                  <vs-th v-text="$t('consultation_contents')"></vs-th>
                  <vs-th class="text-center" v-text="$t('record_file')"></vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td v-text="tr.count"></vs-td>
                    <vs-td v-text="tr.division ? tr.division.name : ''"></vs-td>
                    <vs-td v-html="getResult(tr.result_type)"></vs-td>
                    <vs-td v-text="tr.created_at_date"></vs-td>
                    <vs-td v-text="tr.created_at_time"></vs-td>
                    <vs-td>
                      <a href="#" v-text="tr.title" @click.prevent="editConsultation(tr.memberId, tr.id)"></a>
                    </vs-td>
                    <vs-td>
                      <a href="#" v-text="tr.content" @click.prevent="editConsultation(tr.memberId, tr.id)"></a>
                    </vs-td>
                    <vs-td>
                      <vs-button color="primary" type="border" icon-pack="feather" icon="icon-play" size="small" @click.prevent="playRecording(tr.source_number, tr.unique_id, tr.call_type)"></vs-button>
                    </vs-td>
                  </vs-tr>
                </template>

              </vs-table>
            </div>
          </div>
        </div>
<!--        <vs-button color="primary" type="border" size="small" @click="openOutboundHistoryPopup" v-text="$t('history_view_all')"></vs-button>-->
      </div>
    </div>
  </form>
</template>

<script>

import Cti from '@/models/Cti'
import Consultation from '@/models/Consultation'
import Big from '@/models/Big'
import Utils from '@/helpers/utils'
import ctiWindow from '@/helpers/ctiWindow'
import { EventBus } from '@/../eventbus.js'
import announcementSocket from '@/libs/sockets/announcements'

export default {
  name: 'Shared.Consultations.Outbound',
  data () {
    return {
      hideSection: {
        profile: false,
        councelingManagement: false,
        moreHistory: true
      },
      user: {},
      memberId: 0,
      callbackId: 0,
      memberFormData: {},
      memberFormErrors: {},
      consultationFormData: {},
      consultationFormErrors: {},
      groupOptions : [],
      levelOptions : [],
      divisionOptions : [],
      resultOptions : [],
      bigOptions : [],
      smallOptions : [],
      extensionOptions : [],
      memberCustomFields: [],
      consultationCustomFields: [],
      consultationHistory: {}
    }
  },
  computed: {
    server () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {}
    }
  },
  watch: {
    'consultationFormData.big_type_id' () {
      this.getSmallList()
    }
  },
  mounted () {
    EventBus.$on('initLoadOutboundConsultation', this.initLoadOutboundConsultation)
    EventBus.$on('initSaveOutboundConsultationFormData', this.initSaveOutboundConsultationFormData)
    EventBus.$on('initResetOutboundConsultationFormData', this.initOutboundConsultationFormData)
    announcementSocket.setNode(this.server)
  },
  methods: {
    toggleSection (section) {
      if (section === 'profile') {
        // this.hideSection.profile = (this.hideSection.profile === true) ? false : true
        this.hideSection.profile = !this.hideSection.profile
      } else if (section === 'counceling-management') {
        // this.hideSection.councelingManagement = (this.hideSection.councelingManagement === true) ? false : true
        this.hideSection.councelingManagement = !this.hideSection.councelingManagement
      } else if (section === 'more-history') {
        // this.hideSection.moreHistory = (this.hideSection.moreHistory === true) ? false : true
        this.hideSection.moreHistory = !this.hideSection.moreHistory
      }
    },
    // TODO: Refactor API calls.
    async initOutboundConsultationFormData () {

      this.memberFormData = {
        name: '',
        company_name: '',
        mobile: '',
        landline: '',
        age: '',
        group_id: '',
        level_id: '',
        address: '',
        emails: ''
      }
      this.consultationFormData = {
        assigned_agent_id: '',
        result_type_id: '',
        division_id: '',
        big_type_id: '',
        small_type_id: '',
        title: '',
        content: '',
        alarm: false
      }
      // Set Defaults
      this.memberFormData.level_id = this.memberFormData.level_id === '' ? this.levelOptions[0].value : this.memberFormData.level_id
      this.memberFormData.group_id = this.memberFormData.group_id === '' ? this.groupOptions[0].value : this.memberFormData.group_id
      this.consultationFormData.result_type_id = this.resultOptions.length > 0 ? this.resultOptions[0].value : ''
      this.consultationFormData.division_id = this.divisionOptions.length > 0 ? this.divisionOptions[0].value : ''
      this.consultationFormData.big_type_id = this.bigOptions.length > 0 ? this.bigOptions[0].value : ''
      if (!this.$store.getters.isManager) {
        this.consultationFormData.assigned_agent_id = this.extensionOptions.some(obj => obj.value === this.$store.getters.userInfo.id) ? this.$store.getters.userInfo.id : ''
      }

    },
    async fetchHistory () {
      const response = await Cti.history({companyId: this.companyId, memberId: this.memberId})
      this.consultationHistory = response.data
    },
    async initLoadOutboundConsultation (data) {

      this.$vs.loading({container: '#outboundContainer'})

      this.memberId = data.member_id
      this.callbackId = data.callback_id

      const response = await Consultation.view({ id: this.memberId, callback_id: this.callbackId })

      this.memberFormData = response.data.data.memberFormData
      this.consultationFormData = {
        ...response.data.data.consultationFormData,
        assigned_agent_id: '',
        result_type_id: '',
        division_id: '',
        big_type_id: '',
        small_type_id: '',
        title: '',
        content: '',
        alarm: false
      }

      this.companyId = response.data.meta.companyId
      this.memberId = response.data.meta.memberId
      this.fetchHistory()

      // History
      // this.consultationHistory = response.data.meta.history.data
      // this.consultationHistoryCount = response.data.meta.history.count

      // Member and Consultations
      this.memberCustomFields = response.data.meta.memberCustomFields
      this.consultationCustomFields = response.data.meta.consultationCustomFields

      // v-select options
      this.groupOptions = response.data.meta.options.groups
      this.levelOptions = response.data.meta.options.levels
      this.divisionOptions = response.data.meta.options.divisions
      this.resultOptions = response.data.meta.options.results
      this.bigOptions = response.data.meta.options.bigs
      this.smallOptions = response.data.meta.options.smalls
      this.extensionOptions = response.data.meta.options.extensions
      this.user = response.data.meta.user

      // Set Defaults
      this.memberFormData.level_id = this.memberFormData.level_id === '' ? (this.levelOptions.length > 0 ? this.levelOptions[0].value : '') : this.memberFormData.level_id
      this.memberFormData.group_id = this.memberFormData.group_id === '' ? (this.groupOptions.length > 0 ? this.groupOptions[0].value : '') : this.memberFormData.group_id
      this.consultationFormData.result_type_id = this.resultOptions.length > 0 ? this.resultOptions[0].value : ''
      this.consultationFormData.division_id = this.divisionOptions.length > 0 ? this.divisionOptions[0].value : ''
      this.consultationFormData.big_type_id = this.bigOptions.length > 0 ? this.bigOptions[0].value : ''
      if (!this.$store.getters.isManager) {
        this.consultationFormData.assigned_agent_id = this.extensionOptions.some(obj => obj.value === this.$store.getters.userInfo.id) ? this.$store.getters.userInfo.id : ''
      }

      this.$vs.loading.close('#outboundContainer > .con-vs-loading')

    },
    getResult (status) {
      switch (status.id) {
      case 1:
        return `<span class="text-info">${status.name}</span>`
      case 2:
        return `<span class="text-success">${status.name}</span>`
      case 3:
        return `<span class="text-secondary">${status.name}</span>`
      case 4:
        return `<span class="text-danger">${status.name}</span>`
      }
    },
    openOutboundHistoryPopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'outbound-history', { id: this.memberId })
    },
    editConsultation (memberId, consultationId) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'edit-consultation', { id: memberId, consultationId })
    },
    async getSmallList () {
      try {
        const response = await Big.getSmalls({ id: this.consultationFormData.big_type_id })
        this.smallOptions = []

        for (const small in response.data.smalls) {
          this.smallOptions.push({
            label: response.data.smalls[small],
            value: small
          })
        }

        this.consultationFormData.small_type_id = typeof this.smallOptions[0] !== 'undefined' ? this.smallOptions[0].value : ''
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    },
    async initSaveOutboundConsultationFormData () {

      this.$vs.loading({background: 'primary', color: '#fff', container: '#outboundSaveButton', scale: 0.45})
      try {

        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          await Consultation.storeOutbound({
            memberFormData: this.memberFormData,
            consultationFormData: this.consultationFormData,
            callback_id: this.callbackId
          })

          announcementSocket.getSocket().emit('init_message_management_count')

          this.$emit('outboundConsultationSuccess')
          this.$store.dispatch('setIsFormInProgress', false)

        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.$store.dispatch('setIsFormInProgress', false)
        this.consultationFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#outboundSaveButton > .con-vs-loading')

    },
    playRecording (src, uniqueId, callType) {
      ctiWindow.consultationRecordingFile(src, uniqueId, callType)
    }
  }
}
</script>

<style lang="scss">
  #outboundContainer {
    padding-bottom: 50px;

    .vs-collapse-item--header {
      background-color: #667c8a;
      padding: 8px;
    }

    .actions {
      z-index: 999;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      justify-content: center;
      align-items: center;
      background-color: #eee;
    }
  }
  #outboundSaveButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
